import { defineMessages } from 'react-intl'

const messages = defineMessages({
  cart: {
    id: 'Cart.cart',
    defaultMessage: 'Varukorg',
  },
  emptyCart: {
    id: 'Cart.emptyCart',
    defaultMessage: 'Din varukorg är tom',
  },
  goToCheckout: {
    id: 'Cart.goToCheckout',
    defaultMessage: 'Gå till kassan',
  },
})

export default messages
